import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../../../ui/layout/theme-next/provider';
import { itemStyles } from '../../HelpCenterList.styles';

export default makeStyles<NextTheme>((theme) => ({
  ...itemStyles(theme),
}));
